<template>
    <v-expansion-panel
        v-model="panel"
        expand
    >
        <v-expansion-panel-content
            :key="'expansion-life-' + parentKey"
        >
            <v-flex v-if="type !== 'union'">
                <p class="mortgage-list__data__info__title"><span
                    class="bold-text">{{ type === 'life' ? data.lifeName : data.apartmentName }}</span></p>
                <p v-if="moreInfo.number" class="mortgage-list__data__info__subtitle">
                    Агентский договор: <span class="black-text">{{ moreInfo.number }}</span>
                </p>
                <p v-if="moreInfo.age || moreInfo.total" class="mortgage-list__data__info__title"><span
                    class="bold-text">Условия</span></p>
                <v-layout wrap row>
                    <v-flex lg4 v-if="moreInfo.age">
                        <p class="mortgage-list__data__info__subtitle">
                            Возраст страхователя <br><span class="black-text">{{ moreInfo.age }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="moreInfo.total">
                        <p class="mortgage-list__data__info__subtitle">
                            Страховая сумма <br><span class="black-text black-text__sum">{{ moreInfo.total }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="moreInfo.wear">
                        <p class="mortgage-list__data__info__subtitle">
                            Износ <br><span class="black-text">{{ moreInfo.wear }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="moreInfo.build">
                        <p class="mortgage-list__data__info__subtitle">
                            Год постройки дома <br><span class="black-text">{{ moreInfo.build }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="moreInfo.materials">
                        <p class="mortgage-list__data__info__subtitle">
                            Материалы строения <br><span class="black-text">{{ moreInfo.materials }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="moreInfo.location">
                        <p class="mortgage-list__data__info__subtitle">
                            Территория страхования <br><span class="black-text">{{ moreInfo.location }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="moreInfo.weight">
                        <p class="mortgage-list__data__info__subtitle">
                            Индекс массы тела <br><span class="black-text">{{ moreInfo.weight }}</span>
                        </p>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-else>
                <v-layout row wrap>
                    <v-flex lg2>
                        <p class="mortgage-list__data__info__title">
                            Недвижимость <br><span class="bold-text">{{ data.apartmentName }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg2>
                        <p class="mortgage-list__data__info__title">
                            Жизнь <br><span class="bold-text">{{ data.lifeName }}</span>
                        </p>
                    </v-flex>
                </v-layout>
                <p class="mortgage-list__data__info__subtitle">
                    Агентский договор: <span class="black-text">{{ unionInfoLife.number }}</span>
                </p>
                <p v-if="unionInfoLife.age || unionInfoLife.total || unionInfoLife.location" class="mortgage-list__data__info__title"><span
                    class="bold-text">Условия для страхования жизни</span></p>
                <v-layout row wrap>
                    <v-flex lg4 v-if="unionInfoLife.age">
                        <p class="mortgage-list__data__info__subtitle">
                            Возраст страхователя <br><span class="black-text">{{ unionInfoLife.age }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="unionInfoLife.total">
                        <p class="mortgage-list__data__info__subtitle">
                            Страховая сумма <br><span class="black-text black-text__sum">{{ unionInfoLife.total }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="unionInfoLife.location">
                        <p class="mortgage-list__data__info__subtitle">
                            Территория страхования <br><span class="black-text">{{ unionInfoLife.location }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="unionInfoLife.weight">
                        <p class="mortgage-list__data__info__subtitle">
                            Индекс массы тела <br><span class="black-text">{{ unionInfoLife.weight }}</span>
                        </p>
                    </v-flex>
                </v-layout>
                <p v-if="unionInfoProperty.age || unionInfoProperty.total || unionInfoProperty.build || unionInfoProperty.location || unionInfoProperty.wear" class="mortgage-list__data__info__title"><span
                    class="bold-text">Условия для страхования недвижимости</span></p>
                <v-layout row wrap>
                    <v-flex lg4 v-if="unionInfoProperty.age">
                        <p class="mortgage-list__data__info__subtitle">
                            Возраст страхователя <br><span class="black-text">{{ unionInfoProperty.age }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="unionInfoProperty.total">
                        <p class="mortgage-list__data__info__subtitle">
                            Страховая сумма <br><span class="black-text black-text__sum">{{ unionInfoProperty.total }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="unionInfoProperty.wear">
                        <p class="mortgage-list__data__info__subtitle">
                            Износ <br><span class="black-text">{{ unionInfoProperty.wear }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="unionInfoProperty.build">
                        <p class="mortgage-list__data__info__subtitle">
                            Год постройки дома <br><span class="black-text">{{ unionInfoProperty.build }}</span>
                        </p>
                    </v-flex>
                    <v-flex lg4 v-if="unionInfoProperty.location">
                        <p class="mortgage-list__data__info__subtitle">
                            Территория страхования <br><span class="black-text">{{ unionInfoProperty.location }}</span>
                        </p>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-layout row wrap v-if="type !== 'union'">
                <v-flex xs12 v-if="duration && duration !== ''">
                    <p>Период страхования: <span class="black-text">{{ duration }}</span></p>
                </v-flex>
                <v-layout row wrap class="mortgage-list__data__info__docs" v-if="isResult">
                    <v-flex lg12 md12 xs12>
                        <p class="mortgage-list__data__info__title"><span
                            class="bold-text">Образцы документов</span></p>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs12 v-if="isResult && (data.lifeRequirements || data.apartmentRequirements)">
                        <a :href="type === 'life' ? downloadLink(data.lifeRequirements.life_insurance_example) : downloadLink(data.apartmentRequirements.apartment_insurance_example)"
                           target="_blank">Пример полиса</a>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs12 v-if="isResult && (data.lifeRequirements || data.apartmentRequirements)">
                        <a :href="type === 'life' ? downloadLink(data.lifeRequirements.insurance_rules) : downloadLink(data.apartmentRequirements.insurance_rules)" target="_blank">
                            Правила страхования
                        </a>
                    </v-flex>
                </v-layout>
                <!--                <v-flex xs12 md6>
                                    <a :href="type === 'life' ? downloadLink(data.lifeRequirements.life_insurance_terms) : downloadLink(data.apartmentRequirements.apartment_insurance_terms)" target="_blank">Условия страхования</a>
                                    <a :href="type === 'life' ? downloadLink(data.lifeRequirements.insurance_rules) : downloadLink(data.apartmentRequirements.insurance_rules)" target="_blank">Правила страхования. Жизнь</a><br>
                                </v-flex>
                -->
            </v-layout>
            <v-layout row wrap v-else>
                <!--        TODO: непонятно, откуда брать        -->
                <!--                <v-flex xs12 md6>-->
                <!--                    <p>Год постройки дома: <span class="black-text">после 1980</span></p>-->
                <!--                </v-flex>-->
                <v-flex xs12 v-if="duration && duration !== ''">
                    <p>Период страхования: <span class="black-text">{{ duration }}</span></p>
                </v-flex>
                <v-layout row wrap class="mortgage-list__data__info__docs" v-if="isResult">
                    <v-flex lg12 md12 xs12>
                        <p class="mortgage-list__data__info__title"><span
                            class="bold-text">Образцы документов</span></p>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 mb-2 v-if="data.lifeRequirements">
                        <a :href="downloadLink(data.lifeRequirements.life_insurance_example)" target="_blank">
                            Пример полиса. Жизнь
                        </a>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 mb-2 v-if="data.apartmentRequirements">
                        <a :href="downloadLink(data.apartmentRequirements.apartment_insurance_example)" target="_blank">Пример
                            полиса. Недвижимость</a>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 mb-2 v-if="data.life === data.apartment && data.apartmentRequirements">
                        <a :href="downloadLink(data.apartmentRequirements.complex_insurance_example)" target="_blank">
                            Пример комплексного полиса
                        </a>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 mb-2 v-else-if="data.lifeRequirements">
                        <a :href="downloadLink(data.lifeRequirements.insurance_rules)" target="_blank">
                            Правила страхования <span v-if="data.apartment !== data.life">Жизнь</span>
                        </a>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 mb-2 v-if="data.lifeRequirements.life_insurance_terms">
                        <a :href="downloadLink(data.lifeRequirements.life_insurance_terms)" target="_blank">Условия
                            страхования. Жизнь</a>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 mb-2 v-if="data.apartmentRequirements.apartment_insurance_terms">
                        <a :href="downloadLink(data.apartmentRequirements.apartment_insurance_terms)" target="_blank">Условия
                            страхования. Недвижимость</a>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 mb-2 v-if="data.life === data.apartment && data.apartmentRequirements.complex_insurance_example && data.lifeRequirements.insurance_rules">
                        <a :href="downloadLink(data.lifeRequirements.insurance_rules)" target="_blank">
                            Правила страхования <span v-if="data.apartment !== data.life">Жизнь</span>
                        </a>
                    </v-flex>
                    <!--    <v-flex lg4 md6 sm6 xs12 mb-3 v-if="data.apartment !== data.life && data.apartmentRequirements.insurance_rules">
                                <a :href="downloadLink(data.apartmentRequirements.insurance_rules)" target="_blank">Правила
                                    страхования. Недвижимость</a>
                            </v-flex>
                    -->
                </v-layout>
            </v-layout>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
export default {
    name: "MortgageResultItemInfo",
    props: ['parentKey', 'data', 'type', 'panel', 'duration', 'isResult', 'moreInfo', 'unionInfoLife', 'unionInfoProperty'],
    methods: {
        downloadLink(link) {
            return window.location.origin + link
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgageResultItemInfo.vue